// @ts-check
import React from "react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useAISidebar } from "src/hooks/useAISidebar";
import { AIChatV3Window } from "../AIContent";

export const AINav = () => {
  const { enableAIChat } = useWorkspaceFeatureFlags();

  const { isOpen } = useAISidebar();

  if (!enableAIChat) {
    return null;
  }

  return <AIChatV3Window isOpen={isOpen} />;
};
